export const E_Payment_Mode = {
	INITIAL_PAYMENT: "INITIAL_PAYMENT",
	ADDITIONAL_PAYMENT: "ADDITIONAL_PAYMENT",
}
